module.exports = __webpack_public_path__ + "static/media/dottedArrowRedirection.7e4c9495.svg";